import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "config";

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, initialized } = useSelector((state) => state.auth);

    if (!initialized) {
        return "Protected Route Loading....";
    }

    if (!isAuthenticated) {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }

    return children;
}
